<template>
  <div v-if="isShow" class="popFixed">
    <div class="masking" />
    <div class="tcCon">
      <div class="item">
        <p>您的平台版本较低，不支持身份认证，请升级为最新版本来完成认证。</p>
      </div>
      <div class="btnCon only">
        <span @click="downLoad">去升级</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Download',
  computed: {
    ...mapState(['pageType'])
  },
  data() {
    const u = navigator.userAgent
    return {
      isShow: true,
      isAndroid: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
      isIOS: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    }
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    downLoad() {
      if (this.pageType == 'app') {
        if (this.isIOS) {
          window.location.href = process.env.VUE_APP_DOWNLOAD_IOS
        } else {
          window.location.href = process.env.VUE_APP_DOWNLOAD_ANDR
        }
      }
    }
  }
}
</script>
